import MetricsTable from "../components/MetricsTable";
import MetricsMenu from "../components/MetricsMenu";
import classes from "./Pages.module.css";

export default function MetricsPage() {
  return (
    <div className={classes.page}>
      <MetricsMenu />
      <MetricsTable />
    </div>
  );
}
